"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Image;
exports.withThemeSrc = withThemeSrc;
exports.useThemeSrc = useThemeSrc;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _head = _interopRequireDefault(require("lodash/head"));

var _values = _interopRequireDefault(require("lodash/values"));

var _styles = require("@material-ui/core/styles");

var _constants = require("../../utils/constants");

function Image(props) {
  var src = useThemeSrc(props.src);
  return /*#__PURE__*/_react["default"].createElement("img", (0, _extends2["default"])({}, props, {
    src: src,
    alt: props.alt
  }));
}

function withThemeSrc() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  var srcs = args.filter(Boolean);
  if (srcs.length === 1) return srcs[0];else if (srcs.length > 1) {
    var _ref;

    var _srcs = (0, _slicedToArray2["default"])(srcs, 2),
        lightSrc = _srcs[0],
        darkSrc = _srcs[1];

    return _ref = {}, (0, _defineProperty2["default"])(_ref, _constants.themeMode.LIGHT, lightSrc), (0, _defineProperty2["default"])(_ref, _constants.themeMode.DARK, darkSrc), _ref;
  }
  return '';
}

function useThemeSrc(src) {
  var _useTheme = (0, _styles.useTheme)(),
      palette = _useTheme.palette;

  return (0, _react.useMemo)(function () {
    if ((0, _typeof2["default"])(src) === 'object') {
      return src[palette.type] || (0, _head["default"])((0, _values["default"])(src));
    } else {
      return src;
    }
  }, [src, palette.type]);
}
//# sourceMappingURL=index.js.map